module.exports = __webpack_public_path__ + "img/doctor1.4e945ea8.png";